export default {
  'parallel.form.flow': 'Branch',
  'parallel.form.addFlow': 'Add branch',
  'parallel.form.noFlows': 'No branches yet. Add at least one.',
  'parallel.form.enabled': 'Enabled',
  'parallel.form.disabled': 'Disabled',
  'parallel.form.name': 'Name',
  'parallel.form.description': 'Description',
  'parallel.form.rejectionBehavior': 'Rejection behavior',
  'parallel.form.select.rejectParallelFlow': 'Reject this branch only',
  'parallel.form.select.rejectParallel': 'Reject the parallel action',
  'parallel.form.select.rejectProcessInstance': 'Reject the process instance',
};
